import type { ConceptChipAchievement } from '@mathflat/domain/Achievement'
import { CONCEPT_CHIP_TYPE, type ConceptChipType } from '@mathflat/domain/ConceptChip'
import type { RecentChallengeItem } from '@mathflat/domain/StudentHome'

export default class RecentChallenge {
  readonly littleChapterId: number
  readonly littleChapterName: string
  readonly learningConceptChip: Map<ConceptChipType, number>
  readonly conceptChips: ConceptChipAchievement[]

  constructor(data: RecentChallengeItem) {
    this.littleChapterId = data.littleChapterId
    this.littleChapterName = data.littleChapterName
    this.learningConceptChip = new Map(
      CONCEPT_CHIP_TYPE.map((type) => [type, data.learningConceptChip[type]] as const),
    )
    this.conceptChips = data.conceptChips
  }
}
